<template>
  <section>
    <section class="flex">
      <section class="width-690">
        <section class="flex flex-right mg-b-20">
          <div class="flex-sb-center">
            <el-form
              v-if="step==1"
              ref="finaForm"
              :rules="rules"
              :model="finaForm">
              <div
                class="flex">
                <el-form-item
                  v-if="isFina"
                  ref="referrer_id"
                  :rules="rules.select"
                  class="mg-r-10"
                  prop="referrer_id" >
                  <v-button
                    gray
                    :disabled="!!formData.referrer_id"
                    icon="user-tie"
                    @click="handleAttachReferrer">{{btn_refer_text}}</v-button>
                </el-form-item>
                <v-button
                  v-if="isCreate"
                  gray
                  @click="handlerSave">Save</v-button>
                <v-button
                  red
                  @click="handleCancel">{{isQuote?'Cancel':'Discard'}}</v-button>
                <v-button
                  v-if="isEdit&&!isQuote"
                  green
                  @click="handlerSave">Save</v-button>
                <v-button
                  v-else
                  green
                  @click="handlerNext">Next</v-button>
              </div>
            </el-form>
            <div
              v-if="step==2"
              class="flex">
              <v-button
                gray
                @click="handleBack">Back</v-button>
              <v-button
                v-if="!isQuote"
                green
                @click="handleComplete(1)">Complete Buyable</v-button>
              <v-button
                v-else
                green
                @click="handleComplete(2)">Save</v-button>
            </div>
          </div>
        </section>
        <div>
          <v-serviced-progress
            class="mg-b-20"
            :is-fina="isFina"></v-serviced-progress>
        </div>
        <div class="form-container">
          <sme-kyc-form
            v-if="step==1"
            ref="sme-form"
            :form="formData"
            :is-quote="isQuote"
            :is-create="isCreate"
            :is-fina="isFina"
            :is-next="isNext"
            :isEdit="isEdit"
            @getFormData="getSMEFormData"></sme-kyc-form>
          <reply-form
            v-if="step==2"
            ref="reply-form"
            :form="formData"
            :is-fina="isFina"
            @updateForm="handleUpdateForm"
            @updateRefer="updateRefer"
            @getFormData="getFormData"></reply-form>
          <!--          <lazy-dom-->
          <!--            v-if="step==1"-->
          <!--            notLoading>-->
          <!--            <use-personal-data-->
          <!--              ref="use-personal-data"-->
          <!--              :marketing_data="formData.marketing_data"-->
          <!--              :company_name="formData.company_language"-->
          <!--              @sendData="getData"></use-personal-data>-->
          <!--          </lazy-dom>-->
        </div>
      </section>
      <template v-if="isEdit||isQuote">
        <section class="right mg-l-40">
          <ticket-remark
            :isQuote="isQuote"
            :quoId="form.quo_id"
            :remark="remark"
            :ticket-id="ticketId"></ticket-remark>
        </section>
      </template>
    </section>
    <div class="bottom-btn width-690 mg-t-30">
      <div class="flex-sb-center">
        <div
          v-if="step==1"
          class="flex flex-sb-center flex-1">
          <v-button
            red
            @click="handleCancel">{{isQuote?'Cancel':'Discard'}}</v-button>
          <v-button
            green
            @click="handlerNext">{{isEdit&&!isQuote?'Save':'Next'}}</v-button>
        </div>
        <div
          v-if="step==2"
          class="flex flex-sb-center flex-1">
          <v-button
            gray
            @click="handleBack">Back</v-button>
          <v-button
            v-if="!isQuote"
            green
            @click="handleComplete(1)">Complete Buyable</v-button>
          <v-button
            v-else
            green
            @click="handleComplete(2)">Save</v-button>
        </div>
      </div>
    </div>
    <send-contact-dialog
      v-model="showSMS"
      :form="formData"
      :is-create="isCreate"
      :isFormTicket="isQuote"
      @send="handlerSend"
      @skip="handlerSend"></send-contact-dialog>
    <attach-user
      ref="attach-user"
      can-select-all
      :customer-type="2"
      @handlerSelectCustomer="handlerSelectCustomer"
    />
  </section>
</template>
<script>
import smeKycForm from './sme-kyc-form'
import replyForm from './reply-form'
import sendContactDialog from './send-contact-dialog'
import TicketRemark from '@/views/tickets/components/ticket-remark'
import {editSMETicket,replySMEQuote,addSMETicket,getSMETicketDetail} from '@api/new_sme'
import AttachUser from '@/views/quoting/dialogs/attachCustomer'
import {mapActions, mapState} from 'vuex'
import MixinRules from '@/mixins/rules'
export default {
  name:'EditSmeKyc',
  components:{
    // UsePersonalData,
    smeKycForm,
    replyForm,
    sendContactDialog,
    TicketRemark,
    AttachUser
  },
  mixins:[MixinRules],
  props:{
    form: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    isFina: {
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    isRenewQuote: {
      type: Boolean,
      default: false
    },
    isRenewAdd: {
      type: Boolean,
      default: false
    },
    remark: {
      type: Array,
      default: () => ([])
    },
  },
  data(){
    return{
      showSMS:false,
      isNext:false,
      formData:{
        marketing_data:{},
        company_language:''
      },
      finaForm:{
        referrer_id:''
      },
      personalData:{},
      step:1,
      formParams:{}
    }
  },
  computed:{
    ...mapState('account', ['referCustomerId','selectReferCustomerData']),
    isKeepPreQuote(){
      let {stts} = this.form||{}
      return stts>=210
    },
    merchant_platform(){
      return this.isFina?2:1
    },
    isCAR(){
      let {classId} = this.$route.params
      let {class_id} = this.form||{}
      return classId==79||class_id==79
    },
    btn_refer_text(){
      let text = ''
      if(this.referCustomerId && this.selectReferCustomerData){
        text = this.selectReferCustomerData.isrd_nm.trim() == ''? 'Unnamed Account' : this.selectReferCustomerData.isrd_nm
      }else{
        text = 'Select Referrer'
      }
      if(text.length > 25){
        text = text.substr(0, 25) + '...'
      }
      return text
    },
    isAttachCustomer(){
      let {customer_id}=this.formData||{}
      return customer_id>0||this.isFina
    },
    isRenewFinaToHc(){
      let {type,customer_id,is_guest_order} = this.form||{}
      return customer_id<=0&&is_guest_order!=1
    },
    ticketId(){
      let {ticket_id} =this.$route.query||{}
      if(this.isQuote){
        return this.form.ticket_id
      }
      return ticket_id
    },
    orderId(){
      if(this.isCreate)
        return this.formData.order_id||''
      let {order_id} =this.form||{}
      return order_id||''
    },
  },
  watch: {
    form: {
      immediate:true,
      handler(val) {
        this.formData = {...this.formData,...val}
        let {contractor_data} = val||{}
        this.formData = {...this.formData,...contractor_data}
        let {referrer,referrer_id } = val||{}
        let {detail} = referrer||{}
        if(detail){
          this.setSelectReferCustomerData(detail)
          this.setReferCustomerId(referrer_id)
        }
      }
    },
    referCustomerId:{
      immediate:true,
      handler(val){
        if(val){
          this.finaForm.referrer_id = val
          this.$nextTick(()=>{
            this.$refs['finaForm'].clearValidate(['referrer_id'])
          })
        }
      }
    }
  },
  methods:{
    ...mapActions('coupon', ['setCouponData','setSelectCode']),
    ...mapActions('account', ['setSelectReferCustomerData','setReferCustomerId']),
    handleUpdateForm(params){
      this.formData = {...this.formData,...params}
    },
    handlerSelectCustomer(){
      if(this.isNext){
        this.getSMEFormData()
      }
    },
    handleAttachReferrer(){
      this.isNext = false
      this.$refs['attach-user'].showAttachCustomer()
    },
    handlerSelect(type) {
      if(this.orderId){
        this.$refs.shareGuestCustomer.changeDialog()
      }else{
        this.customer_type = type
        this.$refs.attachCustomer.showAttachCustomer()
      }
    },
    async handlerSave(){
      this.isNext = false
      await this.$refs['sme-form'].lessSubmitForm()
    },
    handleBack(){
      this.scrollTo(0)
      this.step=1
    },
    getData(personalData){
      this.personalData = personalData
    },
    async getSMEFormData(data){
      let {is_guest} =data||{}
      const params = {
        ...data,
        save_request:this.isNext?1:0,
        // ref_agency_id:0
      }
      params.merchant_platform = 1
      if(this.isFina){
        params.referrer_id = this.referCustomerId
        params.merchant_platform = 2
      }
      this.formData = {...this.formData,...params}
      let {customer_id} = this.formData||{}
      if(!customer_id)
        this.formData.customer_id = 0
      if(!this.isAttachCustomer&&is_guest==0&&!this.isRenewFinaToHc){
        delete  this.formData.addr_district
        delete  this.formData.addr_area
        delete  this.formData.addr_region
        delete  this.formData.addr_room
        delete  this.formData.addr_floor
        delete  this.formData.addr_block
        delete  this.formData.addr_building
      }
      let {contents_isrd,stocks_isrd,total_pl_isrd} = this.formData||{}
      // if(!contents_isrd||contents_isrd<=0)
      //   delete this.formData.contents_isrd
      // if(!stocks_isrd||stocks_isrd<=0)
      //   delete this.formData.stocks_isrd
      // if(!total_pl_isrd||total_pl_isrd<=0)
      //   delete this.formData.total_pl_isrd
      if(this.isFina&&!this.referCustomerId){
        setTimeout(()=>{
          this.$refs['attach-user'].showAttachCustomer()
        },500)
        return
      }
      if(!this.isEdit||this.isRenewQuote){
        if(this.isKeepPreQuote){
          this.$ConfirmBox({
            isNewConfirm:true,
            width:500,
            confirmBtn:'Yes',
            cancelBtn:'No',
            isGreen:true,
            message: 'Keep previous quote ?',
            message2: 'Yes = keep quote data ( CS can manual update )<br>No = system quote again  ( CS can manual update)',
          }).then(()=>{
            this.formData.keep_pre_quote =1
            this.handlerStep()
          }).catch(()=>{
            this.formData.keep_pre_quote = 0 
            this.handlerStep()
          })
        }else {
          await this.handlerStep()
        }
      }else {
        this.network().editSMETicket({...this.formData})
      }
    },
    async handlerStep(){
      if(this.isCreate){
        await  this.network().addSMETicket(this.formData)
        await this.network().getSMETicketDetail()
      }
      else
      {
        await this.network().editSMETicket(this.formData)
      }
      if(this.isNext)
      {
        this.step=2
      }
    },
    getFormData(data){
      const params = {
        ...data,
        order_id: this.orderId
      }
      this.formParams = JSON.parse(JSON.stringify(params))
    },
    //reply quote or edit quote 1:reply quote 2.edit quote
    async handleComplete(type){
      let data =  await this.$refs['reply-form'].submitForm()
      this.formData = {...this.formData,data}

      let params = {
        ...data
      }
      let {excess,referrer_net_type,referrer_net_pct} = params||{}
      if(excess.length<=0)
        params.excess =null
      if(Number(referrer_net_type)==1&&Number(referrer_net_pct)==0)
      {
        this.$ConfirmBox({
          message: 'Please note that there is no reward for referrals. Are you sure you want to continue?',
          isNewConfirm:true,
          isGreen:true,
          confirmBtn:'Continue',
          width:500
        }).then(async()=>{
          await this.handleReplyQuote(params)
        })
      }else {
        await this.handleReplyQuote(params)
      }

    },
    async handleReplyQuote(params){
      await this.network().replySMEQuote(params)
      if(this.isFina)
      {
        this.$router.push({
          path: '/quoting/referrer/send/payment',
          query: {
            order_id: this.orderId,
            product_id: 80,
            sme_versions: 3,
          }
        })
      }else
        this.showSMS =true
    },
    async handlerNext(){
      this.isNext = true
      await this.$refs['sme-form'].submitForm()
    },
    handleCancel(){
      if(this.isCreate){
        this.$router.back()
      }else
        this.$emit('refresh')
    },
    updateRefer(data){
      this.formData.referrer = data
    },
    handlerSend(){
      if(this.isCreate){
        this.$router.push({
          path:'/records/quote/detail',
          query:{
            product_id:this.isCAR?81:80,
            order_id:this.formData.order_id
          }
        })
      }
      else
        this.$emit('refresh')
    },
    network(){
      return{
        addSMETicket: async (params) => {
          const {data} = await addSMETicket({
            ...params,
          })
          let {order_id,ticket_id} = data
          this.formData.order_id = order_id
          this.formData.ticket_id = ticket_id

        },
        getSMETicketDetail: async (params) => {
          let {ticket_id} = this.formData
          let {order_id} = this.formData
          const {data} = await getSMETicketDetail({
            ...params,
            id:ticket_id,
            type:0
          })
          let {contractor_data} = data||{}
          this.formData = {...data,ticket_id,order_id,...contractor_data}
          this.scrollTo(0)
        },
        editSMETicket: async (params) => {
          const {data} = await editSMETicket({
            ...params,
            ticket_id:this.ticketId,
          })
          this.scrollTo(0)
          if(this.isEdit)
            this.$emit('refresh')
        },
        replySMEQuote: async (params) => {
          let order_id = this.isCreate?this.formData.order_id:this.orderId
          const {data} = await replySMEQuote({
            ...params,
            order_id:order_id
          })
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.width-690{
  width: 690px;
  max-width: 690px;
  position: relative;
}
.just-end{
  justify-content: end;
}
.mg-l-40{
  margin-left: 40px;
}
.mg-t-30{
  //margin-top: 30px;
}
.flex-right{
  justify-content: end;
}
</style>
